<script setup lang="ts">
import { ref, onMounted } from 'vue'
import SectionSidebar from '@/components/SectionSidebar.vue'
import type { SidebarMenuItem } from '@/components/SectionSidebar.vue'
import SouscriptionWidget from '@/components/SouscriptionWidget.vue'
import walletService from '@/services/walletService'
import { formatAmount } from '@/utils/formatters'

const balance = ref<number | null>(null)

const menuItems: SidebarMenuItem[] = [
  {
    to: '/front/wallet',
    icon: '/public/icons/icon-dashboard.svg',
    label: 'Wallet',
    exact: true,
    initialSidebarOpen: true
  },
  {
    to: '/front/wallet/utilisation',
    icon: '/public/icons/icon-utilisation.svg',
    label: 'Utilisation',
    initialSidebarOpen: true
  }
]

onMounted(async () => {
  try {
    const res = await walletService.getBalance()
    if (res.data) balance.value = res.data.balance || 0
  } catch (e) {
    // silencieux
  }
})
</script>

<template>
  <SectionSidebar :menu-items="menuItems">
    <template #widget>
      
      <SouscriptionWidget />
    </template>
  </SectionSidebar>

  <section class="app-section">
    <div class="page-space-50" />
    <router-view />
  </section>
</template>
